import { render, staticRenderFns } from "./SyncIcon.vue?vue&type=template&id=4e5e9754&scoped=true&"
import script from "./SyncIcon.vue?vue&type=script&lang=js&"
export * from "./SyncIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e9754",
  null
  
)

export default component.exports